import React from "react";

import { Switch, Route } from "react-router-dom";

import InvoiceGenerationPage from "./InvoiceGenerationPage";

const InvoiceGenerationRouter = () => (
  <Switch>
    <Route path="/finance/invoice-generation">
      <InvoiceGenerationPage />
    </Route>
  </Switch>
);

export default InvoiceGenerationRouter;
